module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"deleteTenantButton.errorMessage":"There was an error encountered while deleting this tenant. If everything looks right please contact support so we can help you :)","deleteTenantButton.unauthorisedMessage":"You do not have permission to delete this tenant."}}')
  delete Component.options._Ctor
}
